import {
  FETCH_ALL_USERS_SUCCESS,
  FETCH_ALL_USERS_FAIL,
  BAN_USER_SUCCESS,
  BAN_USER_FAIL,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAIL,
  SERVICE_ACCESS_GRANTED_SUCCESS,
  SERVICE_ACCESS_GRANTED_FAIL,
  FETCH_ALL_DEPARTMENTS_SUCCESS,
  FETCH_ALL_DEPARTMENTS_FAIL,
  CREATE_DEPARTMENT_SUCCESS,
  CREATE_DEPARTMENT_FAIL,
  UPDATE_DEPARTMENT_SUCCESS,
  UPDATE_DEPARTMENT_FAIL,
  DELETE_DEPARTMENT_SUCCESS,
  DELETE_DEPARTMENT_FAIL,
  FETCH_CHAT_TRACKER_USERS_SUCCESS,
  FETCH_CHAT_TRACKER_USERS_FAIL,
  FETCH_CHAT_TRACKER_CONVERSATION_SUCCESS,
  FETCH_CHAT_TRACKER_CONVERSATION_FAIL,
  FETCH_CHAT_TRACKER_STATS_SUCCESS,
  FETCH_CHAT_TRACKER_STATS_FAIL,
  BULK_ASSIGN_DEPARTMENTS_SUCCESS,
  BULK_ASSIGN_DEPARTMENTS_FAIL,
  ASSIGN_USER_DEPARTMENTS_SUCCESS,
  ASSIGN_USER_DEPARTMENTS_FAIL,
  REMOVE_USER_DEPARTMENT_SUCCESS,
  REMOVE_USER_DEPARTMENT_FAIL,
  FETCH_USER_DEPARTMENTS_SUCCESS,
  FETCH_USER_DEPARTMENTS_FAIL,
} from "../Actions/Types";

const initialState = {
  users: [],
  allUsersData: {
    count: 0,
    next: null,
    previous: null,
    results: [],
  },
  departments: [],
  userDepartments: [], // User's assigned departments
  userActiveDepartments: [], // User's active department names
  loading: false,
  error: null,
  chatTrackerData: [],
  chatTrackerConversationData: [],
  chatTrackerStatsData: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_ALL_USERS_SUCCESS:
      return {
        ...state,
        allUsersData: {
          count: action.payload.count,
          next: action.payload.next,
          previous: action.payload.previous,
          results: action.payload.results,
        },
        loading: false,
      };
    case FETCH_ALL_USERS_FAIL:
      return {
        ...state,
        users: [],
        loading: false,
      };
    case BAN_USER_SUCCESS:
      return {
        ...state,
        users: state.users.map((user) =>
          user.id === action.payload.id ? action.payload : user
        ),
        loading: false,
      };
    case BAN_USER_FAIL:
      return {
        ...state,
        loading: false,
      };
    case FETCH_USER_SUCCESS:
      return {
        ...state,
        fetchUserSuccess: true,
        loadingUser: false,
        firstName: action.payload.first_name,
        lastName: action.payload.last_name,
        email: action.payload.email,
        lastLogin: action.payload.last_login,
        isBanned: action.payload.is_banned,
        isAdmin: action.payload.is_staff,
        isSuperuser: action.payload.is_superuser,
        isAppSuperuser: action.payload.is_app_superuser,
        isSubscribed: action.payload.is_subscribed,
        hasAccessToSmartIQ: action.payload.has_access_to_smart_iq,
        hasAccessToSmartExtract: action.payload.has_access_to_smart_extract,
        hasAccessToAI: action.payload.has_access_to_ai,
        hasAccessToMessaging: action.payload.has_access_to_messaging,
        userActiveDepartments: action.payload.active_departments || [],
        userDepartmentsList: action.payload.departments_list || [],
      };
    case FETCH_USER_FAIL:
      return {
        ...state,
        fetchUserSuccess: false,
        loadingUser: false,
        firstName: null,
        lastName: null,
        email: null,
        isAdmin: null,
        isSuperuser: null,
        isAppSuperuser: null,
        isSubscribed: null,
        hasAccessToAnalytics: null,
        hasAccessToAI: null,
        hasAccessToMessaging: null,
      };
    case SERVICE_ACCESS_GRANTED_SUCCESS:
      return {
        ...state,
        users: state.users.map((user) =>
          user.id === action.payload.id ? action.payload : user
        ),
        loading: false,
      };
    case SERVICE_ACCESS_GRANTED_FAIL:
      return {
        ...state,
        loading: false,
      };
    case FETCH_ALL_DEPARTMENTS_SUCCESS:
      return {
        ...state,
        departments: Array.isArray(action.payload?.departments)
          ? action.payload.departments
          : [],
        loading: false,
        error: null,
      };
    case FETCH_ALL_DEPARTMENTS_FAIL:
      return {
        ...state,
        departments: [],
        loading: false,
        error: action.payload,
      };
    case CREATE_DEPARTMENT_SUCCESS:
      return {
        ...state,
        departments: Array.isArray(state.departments)
          ? [...state.departments, action.payload]
          : [action.payload],
        loading: false,
        error: null,
      };
    case CREATE_DEPARTMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case UPDATE_DEPARTMENT_SUCCESS:
      return {
        ...state,
        departments: Array.isArray(state.departments)
          ? state.departments.map((dept) =>
              dept.id === action.payload.id ? action.payload : dept
            )
          : [],
        loading: false,
        error: null,
      };
    case UPDATE_DEPARTMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case DELETE_DEPARTMENT_SUCCESS:
      return {
        ...state,
        departments: Array.isArray(state.departments)
          ? state.departments.filter((dept) => dept.id !== action.payload)
          : [],
        loading: false,
        error: null,
      };
    case DELETE_DEPARTMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case FETCH_CHAT_TRACKER_USERS_SUCCESS:
      return {
        ...state,
        chatTrackerData: action.payload,
        loading: false,
      };
    case FETCH_CHAT_TRACKER_USERS_FAIL:
      return {
        ...state,
        loading: false,
      };
    case FETCH_CHAT_TRACKER_CONVERSATION_SUCCESS:
      return {
        ...state,
        chatTrackerConversationData: action.payload,
        loading: false,
      };
    case FETCH_CHAT_TRACKER_CONVERSATION_FAIL:
      return {
        ...state,
        loading: false,
      };
    case FETCH_CHAT_TRACKER_STATS_SUCCESS:
      return {
        ...state,
        chatTrackerStatsData: action.payload,
        loading: false,
      };
    case FETCH_CHAT_TRACKER_STATS_FAIL:
      return {
        ...state,
        loading: false,
      };
    case BULK_ASSIGN_DEPARTMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case BULK_ASSIGN_DEPARTMENTS_FAIL:
      return {
        ...state,
        loading: false,
      };
    case ASSIGN_USER_DEPARTMENTS_SUCCESS:
      return {
        ...state,
        userDepartments: action.payload.departments || [],
        userActiveDepartments: action.payload.active_departments || [],
        loading: false,
        error: null,
      };
    case ASSIGN_USER_DEPARTMENTS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case REMOVE_USER_DEPARTMENT_SUCCESS:
      return {
        ...state,
        userDepartments: action.payload.departments || [],
        userActiveDepartments: action.payload.active_departments || [],
        loading: false,
        error: null,
      };
    case REMOVE_USER_DEPARTMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case FETCH_USER_DEPARTMENTS_SUCCESS:
      return {
        ...state,
        userDepartments: action.payload.departments || [],
        userActiveDepartments: (action.payload.departments || [])
          .filter(d => d.is_active)
          .map(d => d.department_name),
        loading: false,
        error: null,
      };
    case FETCH_USER_DEPARTMENTS_FAIL:
      return {
        ...state,
        userDepartments: [],
        userActiveDepartments: [],
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
}
